<script>
import axios from 'axios';
import { mapActions, mapState, mapMutations } from 'vuex';
import CopyrightPage from './copyrightPage';
import DataProtectionPage from './dataProtectionPage';

export default {
  name: 'RbxDrawer',
  components: {
    CopyrightPage,
    DataProtectionPage,
  },
  data() {
    return {
      drawer: true,
      mini: false,
      isImpressumDisplayed: false,
      isDataProtectionDisplayed: false,
      hasSubMenu: false,
    };
  },
  computed: {
    ...mapState('app', ['drawerVisible', 'drawerItems', 'auth']),
    getIcon() {
      return this.mini ? 'chevron_right' : 'chevron_left';
    },
  },
  mounted() {
    axios
      .get('/api/roles', {
        params: null,
      })
      .then((response) => {
        const { isAdmin } = response.data;
        const { isResellerUser } = response.data;
        const { isReseller } = response.data;
        const { isResellerAgent } = response.data;
        const { isProcedureDirectoryResponsible } = response.data;
        const { isEmployee } = response.data;
        const { isInvitedToTraining } = response.data;
        const { hasDeleteRights } = response.data;
        const { hasDownloadRights } = response.data;
        const { hasBlogPostRights } = response.data;
        const { isInfoPortalEnabled } = response.data;
        const { isPrivacyAuditsEnabled } = response.data;
        const { isTomsEnabled } = response.data;
        const { isProcedureDirectoriesEnabled } = response.data;
        const { isAvContractsEnabled } = response.data;
        const { isTrainingEnabled } = response.data;
        const { isSharedDocumentsEnabled } = response.data;
        let newDrawerItemList = [];

        this.auth.hasDeleteRights = hasDeleteRights;
        this.auth.hasDownloadRights = hasDownloadRights;
        this.setCurrentUser(response.data.username);

        if (isReseller) {
          if (isResellerAgent) {
            newDrawerItemList = [
              {
                title: 'Benutzerdaten',
                icon: 'person',
                path: '/resellerUser',
              },
              {
                title: 'Mandanten',
                icon: 'assignment_turned_in',
                path: '/clients',
              },
              {
                title: 'Vorlagen',
                icon: 'cloud',
                path: '/sharedDocuments',
              },
              {
                title: 'Fragenkataloge',
                icon: 'menu_book',
                path: '/questionaries',
              },
              {
                title: 'Schulungen',
                icon: 'school',
                path: '/trainingEditorList',
              }];
            if (hasBlogPostRights) {
              newDrawerItemList.push({
                title: 'Infoportal',
                icon: 'article',
                path: '/blogEntries',
              });
            }
          } else {
            newDrawerItemList = [
              {
                title: 'Benutzerdaten',
                icon: 'person',
                path: '/resellerUser',
              },
              {
                title: 'Vertretung',
                icon: 'transfer_within_a_station',
                path: '/resellerAgents',
              },
              {
                title: 'Mandanten',
                icon: 'assignment_turned_in',
                path: '/clients',
              },
              {
                title: 'Vorlagen',
                icon: 'cloud',
                path: '/sharedDocuments',
              },
              {
                title: 'Fragenkataloge',
                icon: 'menu_book',
                path: '/questionaries',
              },
              {
                title: 'Schulungen',
                icon: 'school',
                path: '/trainingEditorList',
              }];
            if (hasBlogPostRights) {
              newDrawerItemList.push({
                title: 'Infoportal',
                icon: 'article',
                path: '/blogEntries',
              });
            }
            newDrawerItemList.push({
              title: 'Ausloggen',
              icon: 'arrow_back',
              path: '/logout',
            });
          }
        } else if (isEmployee) {
          newDrawerItemList = [
            {
              title: 'Schulung',
              icon: 'school',
              path: '/training',
            },
            {
              title: 'Ausloggen',
              icon: 'arrow_back',
              path: '/logout',
            },
          ];
        } else if (isProcedureDirectoryResponsible) {
          newDrawerItemList = [
            {
              title: 'Verfahren',
              icon: 'assignment_late',
              path: '/procedureDirectories',
            },
            {
              title: 'Ausloggen',
              icon: 'arrow_back',
              path: '/logout',
            },
          ];
        } else {
          this.hasSubMenu = true;
          const companyBlock = {
            title: 'Firmendaten',
            icon: 'business',
            items: [],
          };
          if (hasDeleteRights) {
            companyBlock.items.push({
              title: 'Stammdaten',
              icon: 'folder_shared',
              path: '/companies',
            });
          }
          companyBlock.items.push({
            title: 'Benutzer',
            icon: 'person',
            path: '/users',
          });
          companyBlock.items.push({
            title: 'Organisationseinheiten',
            icon: 'work',
            path: '/organizationalUnits',
          });
          companyBlock.items.push({
            title: 'Vertragspartner',
            icon: 'people',
            path: '/affiliates',
          });
          companyBlock.items.push({
            title: 'Mitarbeiter',
            icon: 'person_outline',
            path: '/employees',
          });
          companyBlock.items.push({
            title: 'Abteilungen',
            icon: 'domain',
            path: '/departments',
          });
          const moduleBlock = {
            title: 'Module',
            icon: 'view_module',
            items: [],
          };

          if (isPrivacyAuditsEnabled) {
            moduleBlock.items.push({
              title: 'Audits',
              icon: 'assignment',
              path: '/privacyAudits',
            });
          }
          if (isTomsEnabled) {
            moduleBlock.items.push({
              title: 'TOMs',
              icon: 'assignment_late',
              path: '/toms',
            });
          }
          if (isProcedureDirectoriesEnabled) {
            moduleBlock.items.push({
              title: 'Verfahren',
              icon: 'assignment_late',
              path: '/procedureDirectories',
            });
          }
          if (isAvContractsEnabled) {
            moduleBlock.items.push({
              title: 'AV-Verträge',
              icon: 'assignment_turned_in',
              path: '/avContracts',
            });
          }
          if (isTrainingEnabled) {
            moduleBlock.items.push({
              title: 'Schulungen',
              icon: 'school',
              path: '/trainings',
            });
          }
          if (isSharedDocumentsEnabled && hasDownloadRights) {
            moduleBlock.items.push({
              title: 'Vorlagen',
              icon: 'cloud',
              path: '/sharedDocuments',
            });
          }
          if (isInvitedToTraining) {
            moduleBlock.items.push({
              title: 'Schulung',
              icon: 'school',
              path: '/training',
            });
          }
          if (isInfoPortalEnabled) {
            moduleBlock.items.push({
              title: 'Infoportal',
              icon: 'article',
              path: '/infoPortal',
            });
          }
          if (isAdmin || isResellerUser) {
            moduleBlock.items.push({
              title: 'Jahrestätigkeitsbericht',
              icon: 'text_snippet',
              path: '/activityReport',
            });
          }
          newDrawerItemList = [companyBlock, moduleBlock];
        }
        this.setDrawerItems({ drawerItems: newDrawerItemList });
      })
      .finally(() => {});
  },
  methods: {
    ...mapMutations('app', ['setDrawerItems']),
    ...mapActions('app', ['setCurrentUser']),
    toggleDrawer() {
      this.mini = !this.mini;
    },
  },
};
</script>

<template>
  <div>
    <v-navigation-drawer
      :mini-variant.sync="mini"
      :value="drawerVisible"
      class="drawer-container"
      hide-overlay
      app
      clipped
      absolute
      width="225"
      stateless
    >
      <div v-if="!hasSubMenu">
        <v-list dense>
          <v-list-tile>
            <v-list-tile-action>
              <v-btn icon @click.stop="toggleDrawer">
                <v-icon>{{ getIcon }}</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <template v-for="(item, i) in drawerItems">
            <template>
              <v-list-tile
                :key="i"
                :to="item.path"
                ripple
                :class="item.title == 'Ausloggen' ? 'logout' : ''"
              >
                <v-list-tile-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </template>
        </v-list>
      </div>
      <div v-else>
        <v-list dense>
          <v-list-tile>
            <v-list-tile-action>
              <v-btn icon @click.stop="toggleDrawer">
                <v-icon>{{ getIcon }}</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <template>
            <v-list-tile :key="0" :to="'/dashboard'" ripple>
              <v-list-tile-action>
                <v-icon>dashboard</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Dashboard</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-group v-for="item in drawerItems" :key="item.title" :prepend-icon="item.icon">
            <template slot="activator">
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile v-for="(subitem,i) in item.items" :key="i + 1" :to="subitem.path" ripple>
              <v-list-tile-content>
                <v-list-tile-title>{{ subitem.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-icon>{{ subitem.icon }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

          <v-list-tile to="/logout" class="logout">
            <v-list-tile-action>
              <v-icon>arrow_back</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </div>
      <a
        @click="isImpressumDisplayed = true"
        style="position: absolute; bottom: 10px; left: 16px; font-size: 13px;"
      >Impressum |</a>
      <a
        @click="isDataProtectionDisplayed = true"
        style="position: absolute; bottom: 10px; left: 91px; font-size: 13px;"
      >Datenschutzerklärung</a>
    </v-navigation-drawer>
    <copyright-page v-if="isImpressumDisplayed" @cancel="isImpressumDisplayed = false"/>
    <data-protection-page
      v-if="isDataProtectionDisplayed"
      @cancel="isDataProtectionDisplayed = false"
    />
  </div>
</template>
<style lang="scss">
.logout {
  position: absolute;
  bottom: 38px;
  width: 100%;
}

.drawer-container {
  height: calc(100vh - 48px) !important;
}
</style>
